import React from "react";
import "../css/termsOfService.css";

function TermsOfService() {
  return (
    <div className="terms-container">
      <h1 className="terms-title">Terms of Service</h1>
      <p className="terms-intro">
        Welcome to QueryBox, a product by Retreeval Technologies. By using our services, you agree to these Terms of Service.
      </p>

      <h2 className="terms-subtitle">1. Acceptance of Terms</h2>
      <p>
        By accessing or using QueryBox, you confirm that you accept and agree to these Terms. If you do not agree,
        please discontinue using our services.
      </p>

      <h2 className="terms-subtitle">2. Use of Services</h2>
      <p>
        You agree to use QueryBox only for lawful purposes. You must not misuse our platform, attempt unauthorized access,
        or disrupt its functionality.
      </p>

      <h2 className="terms-subtitle">3. Accounts & Security</h2>
      <p>
        You are responsible for maintaining the confidentiality of your account credentials and for all activity
        that occurs under your account.
      </p>

      <h2 className="terms-subtitle">4. Intellectual Property</h2>
      <p>
        All content, trademarks, and technology used in QueryBox remain the property of Retreeval Technologies or its licensors.
        You may not copy, modify, or distribute them without prior written consent.
      </p>

      <h2 className="terms-subtitle">5. Limitation of Liability</h2>
      <p>
        QueryBox is provided "as is" without warranties of any kind. Retreeval Technologies shall not be held liable
        for damages resulting from the use or inability to use our services.
      </p>

      <h2 className="terms-subtitle">6. Termination</h2>
      <p>
        We may suspend or terminate your access if you violate these Terms or misuse the platform.
      </p>

      <h2 className="terms-subtitle">7. Changes to Terms</h2>
      <p>
        We may update these Terms from time to time. Significant changes will be communicated via email or in-app notifications.
      </p>

      <p className="terms-updated">
        <em>Last updated: September 18, 2025</em>
      </p>
    </div>
  );
}

export default TermsOfService;
